import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../models/Login";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";

export interface ISkillFilter {
    // fromDate?: Date | null,
    // toDate?: Date | null,
    company?: number | null,
    branch?: number | null,
    category?: number | null,
    team?: number | null,
}

export const EmptySkillFilter: ISkillFilter = {
    company: null,
    branch: null,
    category: null,
    team: null,
}

interface IFilterProps {
    skillFilter: ISkillFilter,
    setSkillFilter: (skillFilter: ISkillFilter) => void,
}

const schema = yup.object({
    // fromDate: yup.date().nullable(),
    // toDate: yup.date().nullable(),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    req_Category: yup.number().nullable(),
    team:yup.number().nullable()
});

export const Filter = (props: IFilterProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [teams, setTeams] = useState<Array<ITeamsDropdown>>();



    const { control, handleSubmit, reset, watch } = useForm<ISkillFilter>({
        defaultValues: props.skillFilter,
        resolver: yupResolver(schema),
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    };

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList" ;
        
        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList" ;

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };

    const loadTeam = async (branch: number | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const searchToDB = async (body: ISkillFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptySkillFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSkillFilter(body);
    }

    const onSubmit = (data: ISkillFilter) => {
        searchToDB(data);
    };

    const Clear = () => {
        reset(EmptySkillFilter);
        loadSm(0, 0, 0);
        loadTeam(0, 0, "");
        loadBranches();
        loadCompanies();
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam(0, value.company);
                    loadSm(0, value.company, 0);
                    loadBranches(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranches();
                        loadTeam(control._formValues.branch, value.company);
                        loadSm(control._formValues.branch, value.company, control._formValues.team);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0 && value.branch != null) {
                    loadTeam(value.branch, 0);
                    loadSm(value.branch, 0, 0);
                } else {
                    if (value.branch === 0 && value.branch != null) {
                        loadTeam(value.branch, control._formValues.company);
                        loadSm(value.branch, control._formValues.company, control._formValues.team);
                    }
                }
            }

            if (name === "team") {
                if (value.team != 0 && value.team != null) {
                    loadSm(0, 0, value.team);
                } else {
                    if (value.team === 0 && value.team != null) {
                        loadSm(control._formValues.branch, control._formValues.company, value.team);
                    }
                }
            }

            

        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadTeamManagers = async () => {
        const response = await Fetch("Dropdown/getTeammanager", "GET", null, null, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const _data: Array<ITeamsDropdown> = [];
            data.forEach((item: ITeamsDropdown) => {
                const _item: ITeamsDropdown = {
                    team_ID: item.team_ID,
                    team_Name: item.team_Name
                }
                _data.push(_item);
            });
            setTeams(_data);
        }
    }

    useEffect(() => {
        loadTeam(0, 0);
        loadSm(0, 0, 0);
        loadCompanies();
        loadBranches();
        // loadTeamManagers();
        loadSkillCategories();
    }, []);



    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
            <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
            {/* <JVDropdown column={6} label="Team Manager" control={control} name="teamManager" options={teams} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" /> */}

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
            </div>
        </form>
    );
}